import { Trans } from '@lingui/macro'
import { ButtonPrimary } from 'components/Button'
import Column from 'components/Column'
import { clearWalletError, getWalletError } from 'connection/walletError'
import styled from 'styled-components/macro'
import { ThemedText } from 'theme'

const Page = styled.div`
  display: flex;
  width: 100vw;
  min-height: 100vh;
  padding: 24px;
  background: ${({ theme }) => theme.backgroundBackdrop};
`

const Card = styled(Column)`
  width: 100%;
  max-width: 560px;
  margin: auto;
  padding: 32px;
  border-radius: 24px;
  background: ${({ theme }) => theme.backgroundSurface};
`

const ErrorDetails = styled.pre`
  width: 100%;
  max-height: 240px;
  margin: 0;
  padding: 16px;
  overflow: auto;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  border-radius: 12px;
  color: ${({ theme }) => theme.textPrimary};
  background: ${({ theme }) => theme.backgroundModule};
  font-family: ${({ theme }) => theme.fonts.code};
  font-size: 12px;
  line-height: 18px;
`

export default function WalletErrorPage() {
  const error = getWalletError()
  const details = error
    ? `${error.walletName} ${error.operation} error\n\n${error.stack || error.message}`
    : 'Wallet error details are unavailable.'

  const restartApp = () => {
    clearWalletError()
    window.location.assign('/')
  }

  return (
    <Page>
      <Card gap="lg">
        <Column gap="sm">
          <ThemedText.HeadlineLarge textAlign="center">
            <Trans>Wallet error</Trans>
          </ThemedText.HeadlineLarge>
          <ThemedText.BodySecondary textAlign="center">
            <Trans>MetaMask encountered an error. Restart the app to try again.</Trans>
          </ThemedText.BodySecondary>
        </Column>
        <ErrorDetails>{details}</ErrorDetails>
        <ButtonPrimary onClick={restartApp}>
          <Trans>Restart the app</Trans>
        </ButtonPrimary>
      </Card>
    </Page>
  )
}
